(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'emotion', '../../styles'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('emotion'), require('../../styles'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.emotion, global.styles);
    global.indexCss = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _emotion, _styles) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    display: flex;\n    flex-direction: row;\n  '], ['\n    display: flex;\n    flex-direction: row;\n  ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    font-size: 13px;\n    font-family: ', ';\n    width: 24px;\n    height: 24px;\n    border: solid 2px ', ';\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  '], ['\n    font-size: 13px;\n    font-family: ', ';\n    width: 24px;\n    height: 24px;\n    border: solid 2px ', ';\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  ']),
      _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(['\n    font-family: ', ';\n    font-size: 25px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: 1.28;\n    letter-spacing: normal;\n    color: ', ';\n    margin-bottom: 4px;\n  '], ['\n    font-family: ', ';\n    font-size: 25px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: 1.28;\n    letter-spacing: normal;\n    color: ', ';\n    margin-bottom: 4px;\n  ']),
      _templateObject4 = (0, _taggedTemplateLiteralLoose3.default)(['\n    width: 6%;\n    padding-top: 2.5px;\n  '], ['\n    width: 6%;\n    padding-top: 2.5px;\n  ']),
      _templateObject5 = (0, _taggedTemplateLiteralLoose3.default)(['\n    width: 94%;\n  '], ['\n    width: 94%;\n  ']),
      _templateObject6 = (0, _taggedTemplateLiteralLoose3.default)(['\n    border-bottom: 1px solid #f5f5f5;\n    padding-bottom: 30px;\n  '], ['\n    border-bottom: 1px solid #f5f5f5;\n    padding-bottom: 30px;\n  ']),
      _templateObject7 = (0, _taggedTemplateLiteralLoose3.default)(['\n    padding-bottom: 57px;\n  '], ['\n    padding-bottom: 57px;\n  ']);

  var prussian = _styles.colors.prussian,
      gold = _styles.colors.gold,
      slate = _styles.colors.slate;
  var ProximaNova = _styles.fonts.ProximaNova;


  var styles = {
    numberedRowWrapper: (0, _emotion.css)(_templateObject),
    lineItem: (0, _emotion.css)(_templateObject2, ProximaNova, gold),
    headline2: (0, _emotion.css)(_templateObject3, ProximaNova, prussian),
    optional: (0, _emotion.css)(_templateObject3, ProximaNova, slate),
    lineItemWrapper: (0, _emotion.css)(_templateObject4),
    headlineWrapper: (0, _emotion.css)(_templateObject5),
    borderBottom: (0, _emotion.css)(_templateObject6),
    horizontalRule: (0, _emotion.css)(_templateObject7)
  };

  exports.default = styles;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/NumberedRow/index.css.js
// module id = 2006
// module chunks = 1